export class SpocChangeRequestBulk {}
